import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AudioCallPage() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/video-call', { replace: true }); }, [navigate]);
  return null;
}
